type Props = { texto?: string | null; className?: string };

export default function TextoRico({ texto, className = '' }: Props) {
  if (!texto?.trim()) return null;

  const blocos = texto.split(/\n{2,}/); // linha em branco separa parágrafo

  return (
    <div className={className}>
      {blocos.map((bloco, i) => {
        const linhas = bloco.split('\n');
        const ehLista = linhas.every((l) => l.trim().startsWith('- '));

        if (ehLista) {
          return (
            <ul key={i} className="list-disc pl-5 space-y-1 mb-3">
              {linhas.map((l, j) => (
                <li key={j}>{comNegrito(l.trim().slice(2))}</li>
              ))}
            </ul>
          );
        }

        return (
          <p key={i} className="mb-3 last:mb-0">
            {linhas.map((l, j) => (
              <span key={j}>
                {comNegrito(l)}
                {j < linhas.length - 1 && <br />}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}

// Divide em pedaços e engrossa os que estavam entre ** **.
// Como o texto vira <span>, e não HTML, não há como injetar script.
function comNegrito(linha: string) {
  return linha.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
    p.startsWith('**') && p.endsWith('**') && p.length > 4 ? (
      <strong key={i} className="font-semibold">
        {p.slice(2, -2)}
      </strong>
    ) : (
      <span key={i}>{p}</span>
    ),
  );
}